import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Capability, ComponentIdentifier } from 'src/app/models/service/capability';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'component-resources';

@Injectable({
  providedIn: 'root'
})
export class CapabilitiesService {

  constructor(private fabricService: FabricService) {

  }

  getCapabilities(): Observable<Capability[]> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_capabilities');
  }

  async getCapabilitiesView(component: ComponentIdentifier): Promise<Observable<any>> {
   return await this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_components_name_version', component);
  }
}
